'use client';

import { categories } from '@/@constants';
import { Accordion, Drawer, Icon, Logo } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import InternalLink from '@/components/core/components/organism/internal-link';
import { useLocalizedLinks } from '@/components/core/hooks';
import { Trans } from '@lingui/react/macro';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import * as styles from './side-menu.styles';
import Item from '../item';

const SideMenu: UIComponent = () => {
  const links = useLocalizedLinks();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setAccordionOpen(false);
    setDrawerOpen(false);
  }, [pathname]);
  return (
    <>
      <Icon
        name="burger"
        onClick={() => {
          setDrawerOpen(true);
        }}
      />
      <Drawer
        open={drawerOpen}
        anchor="right"
        className={styles.drawer}
        onClose={() => {
          return setDrawerOpen(false);
        }}
      >
        <Logo />
        <div>
          <Item icon="home" href="/" className={styles.item}>
            <Trans>Home</Trans>
          </Item>
          <Accordion
            expanded={accordionOpen}
            onChange={({ target }) => {
              setAccordionOpen(target.checked);
            }}
            className={styles.discoverAccordion}
          >
            <Accordion.Header>
              <Item icon="search" as="span" className={styles.item}>
                <Trans>Discover</Trans>
              </Item>
            </Accordion.Header>
            <Accordion.Content className={styles.discoverAccordionContent}>
              <InternalLink href={links.explore(categories.restaurants)}>
                <Trans>Restaurants</Trans>
              </InternalLink>
              <InternalLink href={links.explore(categories.movies)}>
                <Trans>Movies</Trans>
              </InternalLink>
              <InternalLink href={links.explore(categories.series)}>
                <Trans>Series</Trans>
              </InternalLink>
              <InternalLink href={links.explore(categories.fashion)}>
                <Trans>Fashion</Trans>
              </InternalLink>
              <InternalLink href={links.explore()}>
                <Trans>Other categories</Trans>
              </InternalLink>
            </Accordion.Content>
          </Accordion>
          <Item icon="map" href={links.map()} className={styles.item}>
            <Trans>Near me</Trans>
          </Item>
        </div>
      </Drawer>
    </>
  );
};

export default SideMenu;
